module.exports = __webpack_public_path__ + "assets/media/day24.ae0d43c0.mp3";